
// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu } from "@headlessui/react";

// const Navbar = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   const handleLinkClick = () => {
//     setIsMenuOpen(false);
//   };

//   return (
//     <header className="fixed top-0 left-0 w-full bg-transparent z-50">
//       <div className="max-w-screen-xl mx-auto px-6 py-4 flex items-center justify-between">
//         {/* Logo */}
//         {/* <div className="flex items-center">
//           <img src="/images/logo5.png" alt="Logo" className="h-16 hidden md:block" />
//         </div> */}
//         <div className="flex items-center">
//   <img
//     src="/images/logo5.png"
//     alt="Logo"
//     width={3561}
//     height={721}
//     loading="lazy"
//     className="h-16 w-auto object-contain hidden md:block"
//   />
// </div>

//         {/* Mobil Menü Butonu */}
//         <button className="md:hidden text-3xl text-black" onClick={() => setIsMenuOpen(!isMenuOpen)}>
//           {isMenuOpen ? "✖" : "☰"}
//         </button>

//         {/* Menü */}
//         <nav
//           className={`fixed top-16 left-1/2 -translate-x-1/2 w-[90%] max-w-[320px] bg-white/80 backdrop-blur-md shadow-xl rounded-xl p-4 md:bg-transparent md:shadow-none md:static md:flex md:space-x-6 text-[15px] font-medium ${
//             isMenuOpen ? "block" : "hidden"
//           } md:block`}
//         >
//           <Link to="/" className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide" onClick={handleLinkClick}>
//             ANASAYFA
//           </Link>
//           <Link to="/kurumsal" className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide" onClick={handleLinkClick}>
//             KURUMSAL
//           </Link>

//           {/* Hizmetler Dropdown */}
//           <Menu as="div" className="relative">
//             <Menu.Button className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide">HİZMETLER</Menu.Button>
//             <Menu.Items className="absolute top-full left-0 mt-2 w-64 bg-green-500 shadow-lg rounded-lg p-2 z-50">
//               {[
//                 { path: "/hali-yikama", label: "HALI YIKAMA" },
//                 { path: "/koltuk-yikama", label: "KOLTUK YIKAMA" },
//                 { path: "/yatak-yikama", label: "YATAK YIKAMA" },
//                 { path: "/stor-zebra-perde-yikama", label: "STOR-ZEBRA PERDE YIKAMA" },
//                 { path: "/yorgan-yikama", label: "YORGAN YIKAMA" },
//                 { path: "/yerinde-yikama", label: "YERİNDE YIKAMA" },
//                 { path: "/kuru-temizleme", label: "KURU TEMİZLEME" },
//                 { path: "/hali-tamir-overlok", label: "HALI TAMİR-OVERLOK" },
//               ].map((service) => (
//                 <Menu.Item key={service.path}>
//                   {({ active }) => (
//                     <Link
//                       to={service.path}
//                       onClick={handleLinkClick}
//                       className={`block px-5 py-2 text-white font-medium ${active ? "bg-green-600" : ""}`}
//                     >
//                       {service.label}
//                     </Link>
//                   )}
//                 </Menu.Item>
//               ))}
//             </Menu.Items>
//           </Menu>

//           {/* Hizmet Bölgeleri Dropdown */}
//           <Menu as="div" className="relative">
//             <Menu.Button className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide">HİZMET BÖLGELERİ</Menu.Button>
//             <Menu.Items className="absolute top-full left-0 mt-2 w-64 bg-gray-500 shadow-lg rounded-lg p-2 z-50">
//               {[
//                 { path: "/yenimahalle-hali-yikama", label: "Yenimahalle" },
//                 { path: "/etimesgut-hali-yikama", label: "Etimesgut" },
//                 { path: "/sincan-hali-yikama", label: "Sincan" },
//                 { path: "/cankaya-hali-yikama", label: "Çankaya" },
//                 // { path: "/kecioren-hali-yikama", label: "Keçiören" },
//                 // { path: "/mamak-hali-yikama", label: "Mamak" },
//                 // { path: "/altindag-hali-yikama", label: "Altındağ" },
//               ].map((location) => (
//                 <Menu.Item key={location.path}>
//                   {({ active }) => (
//                     <Link
//                       to={location.path}
//                       onClick={handleLinkClick}
//                       className={`block px-5 py-2 text-white font-medium ${active ? "bg-gray-600" : ""}`}
//                     >
//                       {location.label}
//                     </Link>
//                   )}
//                 </Menu.Item>
//               ))}
//             </Menu.Items>
//           </Menu>

//           <Link to="/blog" className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide" onClick={handleLinkClick}>
//             BLOG
//           </Link>
//           <Link to="/galeri/koltuk-yikama" className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide" onClick={handleLinkClick}>
//             FOTO GALERİ
//           </Link>
//         </nav>
//       </div>
//     </header>
//   );
// };

// export default Navbar;
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "@headlessui/react";

const services = [
  { path: "/hali-yikama", label: "Halı Yıkama" },
  { path: "/koltuk-yikama", label: "Koltuk Yıkama" },
  { path: "/yatak-yikama", label: "Yatak Yıkama" },
  { path: "/stor-zebra-perde-yikama", label: "Stor-Zebra Perde Yıkama" },
  { path: "/yorgan-yikama", label: "Yorgan Yıkama" },
  { path: "/yerinde-yikama", label: "Yerinde Yıkama" },
  { path: "/kuru-temizleme", label: "Kuru Temizleme" },
  { path: "/hali-tamir-overlok", label: "Halı Tamir-Overlok" },
];

const locations = [
  { path: "/yenimahalle-hali-yikama", label: "Yenimahalle" },
  { path: "/etimesgut-hali-yikama", label: "Etimesgut" },
  { path: "/sincan-hali-yikama", label: "Sincan" },
  { path: "/cankaya-hali-yikama", label: "Çankaya" },
];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  const linkClass = ({ isActive }) =>
    `relative block px-4 py-2 text-[14px] font-semibold tracking-wide transition-all duration-300
    ${
      isActive
        ? "text-green-700 after:absolute after:left-4 after:right-4 after:-bottom-1 after:h-[2px] after:bg-green-600"
        : "text-gray-800 hover:text-green-700"
    }`;

  return (
    <header
      // // className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
      // //   scrolled
      // //     ? "bg-white/95 backdrop-blur-md shadow-md"
      // //     : "bg-white/80 md:bg-transparent"
      // // }`}
      // className="fixed top-0 left-0 w-full z-50 bg-transparent"

     
  className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
    scrolled
      ? "bg-white/1 "
      : "bg-white/98  "
  }`}

    >
      <div className="max-w-screen-xl mx-auto px-5 md:px-8 py-3 flex items-center justify-between">
        
        {/* Logo */}
        <NavLink to="/" onClick={handleLinkClick} className="flex items-center">
          <img
            src="/images/logo.png"
            alt="Abone Halı Yıkama Logo"
            width={3561}
            height={721}
            loading="lazy"
            className="h-12 md:h-16 w-auto object-contain"
          />
        </NavLink>

        {/* Mobil Menü Butonu */}
        <button
          className="md:hidden w-11 h-11 flex items-center justify-center rounded-lg border border-gray-200 bg-white text-2xl text-gray-800 shadow-sm"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Menüyü Aç/Kapat"
        >
          {isMenuOpen ? "✕" : "☰"}
        </button>

        {/* Menü */}
        <nav
          className={`
            absolute md:static top-[76px] left-1/2 md:left-auto -translate-x-1/2 md:translate-x-0
            w-[92%] md:w-auto max-w-[360px] md:max-w-none
            bg-white md:bg-transparent
            rounded-2xl md:rounded-none shadow-2xl md:shadow-none
            p-4 md:p-0
            md:flex md:items-center md:gap-1
            transition-all duration-300
            ${isMenuOpen ? "block" : "hidden"} md:flex
          `}
        >
          <NavLink to="/" className={linkClass} onClick={handleLinkClick}>
            ANASAYFA
          </NavLink>

          <NavLink to="/kurumsal" className={linkClass} onClick={handleLinkClick}>
            KURUMSAL
          </NavLink>

          {/* Hizmetler Dropdown */}
          <Menu as="div" className="relative">
            <Menu.Button className="w-full md:w-auto text-left px-4 py-2 text-[14px] font-semibold tracking-wide text-gray-800 hover:text-green-700 transition">
              HİZMETLER
            </Menu.Button>

            <Menu.Items className="md:absolute md:top-full md:left-0 mt-2 w-full md:w-72 bg-white border border-gray-100 shadow-xl rounded-xl p-2 z-50">
              {services.map((service) => (
                <Menu.Item key={service.path}>
                  {({ active }) => (
                    <NavLink
                      to={service.path}
                      onClick={handleLinkClick}
                      className={`block px-4 py-2 rounded-lg text-sm font-medium transition ${
                        active
                          ? "bg-green-50 text-green-700"
                          : "text-gray-700 hover:bg-green-50 hover:text-green-700"
                      }`}
                    >
                      {service.label}
                    </NavLink>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </Menu>

          {/* Hizmet Bölgeleri Dropdown */}
          <Menu as="div" className="relative">
            <Menu.Button className="w-full md:w-auto text-left px-4 py-2 text-[14px] font-semibold tracking-wide text-gray-800 hover:text-green-700 transition">
              HİZMET BÖLGELERİ
            </Menu.Button>

            <Menu.Items className="md:absolute md:top-full md:left-0 mt-2 w-full md:w-64 bg-white border border-gray-100 shadow-xl rounded-xl p-2 z-50">
              {locations.map((location) => (
                <Menu.Item key={location.path}>
                  {({ active }) => (
                    <NavLink
                      to={location.path}
                      onClick={handleLinkClick}
                      className={`block px-4 py-2 rounded-lg text-sm font-medium transition ${
                        active
                          ? "bg-green-50 text-green-700"
                          : "text-gray-700 hover:bg-green-50 hover:text-green-700"
                      }`}
                    >
                      {location.label}
                    </NavLink>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </Menu>

          <NavLink to="/blog" className={linkClass} onClick={handleLinkClick}>
            BLOG
          </NavLink>

          <NavLink
            to="/galeri/koltuk-yikama"
            className={linkClass}
            onClick={handleLinkClick}
          >
            FOTO GALERİ
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;